<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ifr2ou/tc-custom/9781667444055.jpg?1682168953995" alt="This image is the cover for the book Investindo no Amor, Série Banqueiro Bilionário #3"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Investindo no Amor, Série Banqueiro Bilionário #3
      </h1>
      <p class="bookDescription body article font2">
        <p>Da autora best seller do USA Today, Lexy Timms.<br/> Ame como se você nunca estivesse contando o custo.<br/> Kirk Sterling não via Bethany Walker desde que deu o fora nela. Ele havia terminado com ela para protegê-la de sua poderosa família, mas não a superou. Quando Bethany aparece, desesperada por sua ajuda, Kirk concorda, pronto para resistir ao seu charme sedutor. <br/> Após seu rompimento com Kirk, Bethany Walker manteve distância, trabalhando duro para superar sua mágoa. Mas ela descobre que seu pai está em perigo e Kirk é o único homem a quem ela pode recorrer para pedir ajuda. Ver Kirk novamente ameaça reacender a rixa entre suas famílias; o pior de tudo, é que coloca em perigo seu coração sofrido.<br/> Trabalhar junto é o desafio mais difícil que qualquer um dos dois já enfrentou. À medida que descobrem os segredos do passado e se aproximam da verdade chocante, o perigo espreita a cada esquina. Será que Kirk e Bethany reavivarão seu relacionamento ou a guerra entre suas famílias consumirá os dois?<br/> Livro 1 – Confiando Nele<br/> Livro 2 – O Preço da Paixão<br/> Livro 3 – Investindo no Amor<br/> Livro 4 – Conhecendo Seu Valor<br/> Livro 5 – Treasured Forever <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lexy Timms, Ju Pinheiro
      </h2>
      
      <p class="authorDescription body article">"O amor deveria ser algo que dura para sempre, não que está perdido para sempre."<br/> Visite a autora best seller do USA Today Lexy Timms<br/> https://www.facebook.com/SavingForever<br/> Por favor, sinta-se à vontade para entrar em contato comigo e compartilhar seus comentários. Adoro entrar em contato com meus leitores.<br/> Cadastre-se para notícias, atualizações e brindes - Adoro mimar meus leitores!<br/> http://eepurl.com/9i0vD<br/> website: www.lexytimms.com<br/> Lidar com joias antigas e sair com seu marido incrível e três filhos, Lexy Timms ama escrever no seu tempo livre.<br/> LIDANDO COM OS CHEFES é uma série bestseller internacional em 16 partes que mergulha nas vidas de Alex Reid e Jamie Connors. Pode uma secretária realmente se apaixonar pelo seu chefe bilionário?<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b576aa6